import ConfirmationDialog from "../../../components/ConfirmationDialog";
import React from "react";

export const ExceptionDeleteConfirm = ({headerText, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { props.onClose }
        cancelButton={{
            action: props.onClose,
            label: 'No, Cancel'
        }}
        acceptButton={{
            action: props.onAccept,
            label: 'Yes, Delete'
        }}
        header={headerText}
    />;

export default ExceptionDeleteConfirm;
